export default __webpack_public_path__ + "static/GT-America-Condensed-Black-a34b5aa47aee3db04e47c54164e3edc5.woff";